import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router'
import defaultLayout from '../layouts/defaultLayout.vue';
import adminlayout from "@/layouts/adminLayout.vue";
import dashboard from '../views/dashboard.vue';
import process from '../views/process.vue';
import tasks from '../views/tasks.vue';
import archiveTemplates from '../views/archiveTemplates.vue';
import template from '../views/template.vue';
import createTemplate from '@/views/createTemplate.vue';
import templateDetails from '@/views/templateDetails.vue';
import templateTaskEdit from '@/views/templateTaskEdit.vue';
import SubTaskEdit from '@/views/SubTaskEdit.vue';
import testSubTaskEdit from '@/views/testSubTaskEdit.vue';
import testTemplateTaskEdit from '@/views/testTemplateTaskEdit.vue';
import viewArchiveTemplateInformation from '@/views/viewArchiveTemplateInformation.vue';
import store from "@/store";
import DummyTasks from '@/views/dummyTasks.vue';

const routes: Array<RouteRecordRaw> = [

  {
    path: '/',
    name: 'default',
    meta: {
        title: "Dashboard",
        layout: defaultLayout,
    },
    redirect: { name: 'process' }
  },

  {
    path: '/admin',
    name: 'default-admin',
    meta: {
        title: "Dashboard",
        layout: adminlayout,
    },
    redirect: { name: 'process' }
  },
  {
    path: "/org/planner/dashboard",
    name: "dashboard",
    meta: {
        title: "Dashboard",
        layout: defaultLayout,
    },
    component: dashboard,
  },
  {
    path: "/org/planner/process",
    name: "process",
    meta: {
        title: "Process",
        layout: defaultLayout,
    },
    component: process,
  },
  {
    path: "/planner/tasks",
    alias: "/org/planner/tasks",
    name: "tasks",
    meta: {
        title: "tasks",
        layout: defaultLayout,
    },
    component: tasks,
  },
   {
    path: "/planner/tasks/test",
    name: "dummyTasks",
    meta: {
        title: "dummyTasks",
        layout: defaultLayout,
    },
    component: DummyTasks,
  },
  {
    path: "/planner/archiveTemplates",
    name: "archiveTemplates",
    meta: {
        title: "archiveTemplates",
        layout: defaultLayout,
    },
    component: archiveTemplates,
  },
  {
    path: "/planner/archiveTemplates/:templateId",
    name: "viewArchiveTemplateInformation",
    meta: {
        title: "viewArchiveTemplateInformation",
        layout: defaultLayout,
    },
    component: viewArchiveTemplateInformation,
  },
  {
    path: "/org/process/:processId/templates",
    name: "template",
    meta: {
        title: "template",
        layout: defaultLayout,
    },
    component: template,
  },
  {
    path: "/org/process/:processId/createTemplate",
    name: "createTemplate",
    meta: {
        title: "createTemplate",
        layout: defaultLayout,
    },
    component: createTemplate,
  },
  {
    path: "/org/process/:processId/edit/:templateId/editTemplate",
    name: "editTemplate",
    meta: {
        title: "editTemplate",
        layout: defaultLayout,
    },
    component: createTemplate,
  },
  {
    path: "/org/process/:processId/template/:templateId/templateDetails",
    name: "templateDetails",
    meta: {
        title: "templateDetails",
        layout: defaultLayout,
    },
    component: templateDetails,
  },
  {
    path: "/org/process/:taskId/task",
    name: "templateTaskEdit",
    meta: {
        title: "templateTaskEdit",
        layout: defaultLayout,
    },
    component: templateTaskEdit,
  },
   {
    path: "/org/process/:taskId/task/test",
    name: "testTemplateTaskEdit",
    meta: {
        title: "testTemplateTaskEdit",
        layout: defaultLayout,
    },
    component: testTemplateTaskEdit,
  },
  {
    path: "/org/process/:taskId/task/:subtaskId/subTask",
    name: "subTaskEditfromtask",
    meta: {
        title: "subTaskEditfromtask",
        layout: defaultLayout,
    },
    component: SubTaskEdit,
  },
  {
    path: "/org/process/:subtaskId/subTask",
    name: "subTaskEdit",
    meta: {
        title: "subTaskEdit",
        layout: defaultLayout,
    },
    component: SubTaskEdit,
  },
  {
    path: "/org/process/test/:subtaskId/subTask",
    name: "testSubTaskEdit",
    meta: {
        title: "testSubTaskEdit",
        layout: defaultLayout,
    },
    component: testSubTaskEdit,
  },
  {
    path: '/error',
    name: 'error',
    meta: {
        title: 'error',
        layout: 'empty-layout',
    },
    props:true,
    component: () => import('@/components/error.vue')
    },
    {
    path: '/:pathMatch(.*)*',
    redirect: '/error',
    },
]

const router = createRouter({
  history: createWebHistory('/'),
  routes,
});
router.beforeEach(async (to, from, next) => {
  store.state.isLoading = true;
  if(to.meta.title){
      document.title=`Planner - ${to.meta.title}`
  }
  else{
      document.title=`Planner`
  }
  if ( to.path == '/admin' ||  to.path == '/' || to.path=='/org/planner/process') {
      if (to.query.session) {
          localStorage.setItem('AUTH_ID', to.query.session.toString());
          await store.dispatch('getUserInfo').then(async(res) => {
              const userInfo = await checkUserPermissions();  // Check user permissions locally
              if (!res.data[0]) window.location.href = `${process.env.VUE_APP_AUTH_UI}/session?returnTo=${process.env.VUE_APP_PLANNER_UI}`;
              else {
                if(res.data&& res.data[0].organisationType==10702 && res.data[0].roles && res.data[0].roles.length>0) {
                        const roles = res.data[0].roles;
                        let isActive = roles.find((role:any)=>role.appId==10007 && role.isActive==false);
                        if(isActive!=undefined){
                            router.replace({ name: 'error', query: { code: '403' } });
                            store.state.isLoading = false; // stop loading spinner if you use it
                            return Promise.reject('Access Denied');
                        }  
                }
                let roleId:any;
                    if(res.data[0].organisationType==10701){
                        roleId = res.data[0].role_id;
                    }
                    else if(res.data[0].organisationType==10702) {
                        roleId = res.data[0].roleId;
                    }                                           
                    if (to.path === '/org/planner/process') {
                        if (roleId == 10216) {
                          return next('/org/planner/process');
                        }
                        if (roleId == 10214 || roleId == 10215) {
                          return next('/org/planner/dashboard');
                        }
                    }
                  next();
              }
          })
      }
      await normalAuthenticationCheck(next);
  } else {
      await normalAuthenticationCheck(next);
  }
  // next();
});

router.afterEach(async (to, from, next) => {
  store.state.isLoading = false
});

const checkUserPermissions =async()=> {
    const user:any = store.state.user;    
    if(user!=undefined&& user.organisationType==10702 && user.roleId==10217){
      router.replace({ name: 'error', query: { code: '403' } });
        store.state.isLoading = false; // stop loading spinner if you use it
        return Promise.reject('Access Denied'); // Reject promise to stop further flow
    }
    else if(user!=undefined && user.organisationType==10701 && (user.role_id==10217)){      
        router.replace({ name: 'error', query: { code: '403' } });
        store.state.isLoading = false; // stop loading spinner if you use it
        return Promise.reject('Access Denied'); // Reject promise to stop further flow
    }
    return Promise.resolve(); // User is allowed, return resolved promise
}


async function normalAuthenticationCheck(next: any) {
  if(!localStorage.getItem('AUTH_ID')) {
      window.location.href = `${process.env.VUE_APP_AUTH_UI}/session?returnTo=${process.env.VUE_APP_PLANNER_UI}`;
  } else{
      const userInfo = store.getters.userInfo;
      if(!userInfo.roles) {
          await store.dispatch('getUserInfo').then(async(res) => {
            if(res.data&& res.data[0].organisationType==10702 && res.data[0].roles && res.data[0].roles.length>0) {
                        const roles = res.data[0].roles;
                        let isActive = roles.find((role:any)=>role.appId==10007 && role.isActive==false);
                        if(isActive!=undefined){
                            router.replace({ name: 'error', query: { code: '403' } });
                            store.state.isLoading = false; // stop loading spinner if you use it
                            return Promise.reject('Access Denied');
                        }          
            }
            // const user = await checkUserPermissions();  // Check user permissions locally
               if(res.data[0].organisationType==10702 &&(res.data[0].roleId==10215 || res.data[0].roleId==10216)){
                    next();
                }
                else if(res.data[0].organisationType==10701 && !res.data[0].apps&& res.data[0].domainId!=111111){
                    next({ name: "errorPage", query: { code: 403 }});
                    return;
                }
                else if(res.data[0].organisationType==10702 && res.data[0].roleId==10217){
                    next({ name: "errorPage", query: { code: 403 }});
                    return;
                }
                else {
                    next();
                }
          });
      }
      else{
          next();
      }
  }
}


export default router
